import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IUnrestrictedInternalTransfersQuery } from '../../types/accounting/query/IUnrestrictedInternalTransfersQuery';
import {
  IUnrestrictedInternalTransferResponse,
  IUnrestrictedInternalTransfersResponse,
} from '../../types/accounting/response/IUnrestrictedInternalTransfersResponse';
import { IUnrestrictedInternalTransferData } from '../../types/accounting/data/IUnrestrictedInternalTransferData';
import { DateTime } from 'luxon';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { convertFromIPaginationQueryToIPaginationQueryRequest } from 'types/rest/IPaginationQueryRequest';
import { convertFromISortQueryToISortQueryRequest } from 'types/rest/ISortQueryRequest';
import { convertFromIQueryResponseToIPageData, IPageData } from 'types/rest/IPageData';

const convertToApiQuery = ({
  amountCents,
  memo,
  fileNumber,
  sourceAccount,
  destinationAccount,
  processingStatus,
  createdAt,
  unrestricted,
  ...rest
}: IUnrestrictedInternalTransfersQuery) => ({
  amountCents,
  destinationAccount,
  fileNumber,
  memo,
  processingStatus,
  sourceAccount,
  unrestricted,
  createdAtStart: createdAt && DateTime.fromISO(createdAt[0]).toISO(),
  createdAtEnd: !!createdAt && !!createdAt[1] ? DateTime.fromISO(createdAt[1]).endOf('day').toISO() : undefined,
  ...convertFromIPaginationQueryToIPaginationQueryRequest(rest),
  ...convertFromISortQueryToISortQueryRequest(rest),
});

export const convertExpectedInternalTransferResponseToData = (
  response: IUnrestrictedInternalTransferResponse
): IUnrestrictedInternalTransferData => ({
  amountCents: response.amountCents,
  category: response.category,
  createdAt: response.createdAt,
  destinationAccount: response.destinationAccount,
  escrowFile: response.escrowFile,
  id: response.id,
  memo: response.memo,
  processingForDisbursementCompletedAt: response.processingForDisbursementCompletedAt,
  sourceAccount: response.sourceAccount,
});

export const getExpectedInternalTransfersAsync = async (
  query: IUnrestrictedInternalTransfersQuery
): Promise<IPageData<IUnrestrictedInternalTransferData>> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IUnrestrictedInternalTransfersResponse>(`/timber/api/internal/escrow/expected_internal_transfers`, {
      params: convertToApiQuery(query),
    })
    .then((response) =>
      convertFromIQueryResponseToIPageData(response.data, convertExpectedInternalTransferResponseToData)
    )
    .catch(axiosErrorHandler);
